export default {
  'ab-tasty': false,
  'canonical-urls': true,
  'cookie-banner': false,
  'course-rating-schema': false,
  'dato-route-updated-paths': true,
  'hide-part-time-for-masters': true,
  'pdp-hero-form': false,
} satisfies Record<string, boolean>;
